import GroupSharedDirectory from "../components/GroupSharedDirectory";

/* Group funeral directors — /overview/fds. Every FD across the group, one
   business at a time, plus the Global group (FDs marked `shared`, whose
   commission rate applies in every business). See GroupSharedDirectory
   for the data and write contracts. */

const SEARCH = ["business_name", "code", "owner_name", "manager_name", "email_address", "address"];

const initials = (name) =>
  String(name || "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("") || "FD";

function FdCard(fd, { isGlobal, ownerName }) {
  const contact = fd.manager_name || fd.owner_name;
  const pct = Number(fd.commission_pct) || 0;
  return (
    <span className="gp-item-body gp-fd">
      <span className="gp-fd-top">
        <span className="gp-fd-mark">{initials(fd.business_name)}</span>
        <span className="gp-fd-title">
          <span className="gp-name">{fd.business_name || "Unnamed"}</span>
          <span className="gp-tag">{fd.code ? `Code ${fd.code}` : "No code"}</span>
        </span>
      </span>
      <span className="gp-fd-lines">
        {contact && <span>{contact}</span>}
        {fd.contact_number && <span className="ov-num">{fd.contact_number}</span>}
        {fd.address && <span className="gp-fd-addr">{fd.address}</span>}
      </span>
      <span className="gp-meta">
        <span className={`gp-fd-pct${pct ? "" : " is-zero"}`}>
          {pct ? `${pct}% commission` : "No commission"}
        </span>
        {isGlobal && (
          <span className="gp-owner" title="Created by">
            {ownerName}
          </span>
        )}
      </span>
    </span>
  );
}

export function GroupFdsPage() {
  return (
    <GroupSharedDirectory
      pageTitle="Group funeral directors"
      heading="Funeral directors across the group"
      noun="funeral director"
      nounPlural="funeral directors"
      fetchUrl="/group/fds"
      listKey="fds"
      countsKey="fds"
      bulkUrl="/fd/bulk"
      searchFields={SEARCH}
      searchPlaceholder="Search name, code, contact or address"
      renderItem={FdCard}
      gridClass="gp-grid-fd"
    />
  );
}

export default GroupFdsPage;
